import { createClient } from '@supabase/supabase-js';
import type { Database } from './database.types';
import { logger } from './logger';

// Supabase configuration
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || '';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || '';

if (!supabaseUrl || !supabaseAnonKey) {
  logger.error('Missing Supabase credentials');
}

// Create a single supabase client for interacting with your database
// Typed with our generated Database types
export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey);
